import enumify from './enumify';

export const LEAF_NODES_ONLY = -1;

export default enumify({ LEAF_NODES_ONLY });
